import { Box, Checkbox, FormControlLabel, FormGroup, TextField } from '@mui/material'
import { FC, useEffect } from 'react'
import { Loader } from '~/shared/ui'
import { useMutation } from '~/shared/hooks/useMutation'
import * as AppointmentService from '../AppointmentService'

type CustomAppointmentBookingReasonProps = {
  setCustomAppointmentReasons: (value: string[]) => void
  customAppointmentReasons: string[]
  setSelectedCustomReasons: (value: string[]) => void
  selectedCustomReasons: string[]
  setOtherReason: (value: string) => void
  otherReason: string
  physicianId?: number
  patientId?: number
  reason?: string
  appointmentDateTime?: string
}

const CustomAppointmentBookingReason: FC<CustomAppointmentBookingReasonProps> = ({
  setCustomAppointmentReasons,
  customAppointmentReasons,
  setSelectedCustomReasons,
  selectedCustomReasons,
  otherReason,
  setOtherReason,
  physicianId,
  patientId,
  reason,
  appointmentDateTime,
}) => {
  const { loading: loadingAdditionalReasons, handler: loadAdditionalReasons } = useMutation(
    async () => {
      if (physicianId && reason && appointmentDateTime) {
        const result = await AppointmentService.getAdditionalReasonsForCustomAppointment({
          physicianId: physicianId,
          patientId: patientId,
          reason: reason,
          appointmentDateTime: appointmentDateTime,
        })
        if (result.additional_reasons.length > 0) {
          setCustomAppointmentReasons([
            ...customAppointmentReasons,
            ...result.additional_reasons,
            'Other',
          ])
        } else {
          if (!customAppointmentReasons.includes('Other')) {
            setCustomAppointmentReasons([...customAppointmentReasons, 'Other'])
          }
        }
        return result
      }
    },
  )

  useEffect(() => {
    void loadAdditionalReasons()
    // This step is only reached once the physician, reason and date are chosen, so loading
    // on mount is the whole requirement.
  }, [loadAdditionalReasons])

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    const isChecked = event.target.checked

    if (isChecked) {
      setSelectedCustomReasons([...selectedCustomReasons, value])
    } else {
      setSelectedCustomReasons(selectedCustomReasons.filter(reason => reason !== value))
    }
  }

  return (
    <>
      {loadingAdditionalReasons && <Loader />}
      {!loadingAdditionalReasons && (
        <Box sx={{ m: 2, marginBottom: 6 }}>
          <FormGroup>
            {customAppointmentReasons.map((reason, i) => (
              <FormControlLabel
                key={i}
                control={
                  <Checkbox
                    checked={selectedCustomReasons.includes(reason)}
                    value={reason}
                    onChange={handleCheckboxChange}
                    name={reason}
                    color="primary"
                  />
                }
                label={reason}
              />
            ))}
          </FormGroup>
          {selectedCustomReasons.length > 0 && selectedCustomReasons.includes('Other') && (
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={otherReason}
              onChange={e => setOtherReason(e.target.value)}
              multiline={true}
              fullWidth
              placeholder="Add reason"
            />
          )}
        </Box>
      )}
    </>
  )
}

export default CustomAppointmentBookingReason
